import { IResponse } from "./common.api.model";

export interface IAuth {
  memberCode: string;
  memberType: string;
  korName: string;
  engName: string;
  groupNo: number;
  groupKorName: string;
  groupEngName: string;
  authGroupDiv: string;
  passwdChangeRequiredYn: string;
  hqYn: string;
  campus: string[];
  loginIp: string;
  mobilePhone: string;
  webId: string;
  profileImage: {
    attachFileCode: number;
    fileSeq: number;
    fileLocation: string;
    originalName: string;
    thumbnailLocation: string;
  } | undefined
}

export const InitialAuth: IAuth = {
  memberCode: '',
  memberType: '',
  korName: '',
  engName: '',
  groupNo: 0,
  groupKorName: '',
  groupEngName: '',
  authGroupDiv: '',
  passwdChangeRequiredYn: '',
  hqYn: '',
  campus: [],
  loginIp: '',
  mobilePhone: '',
  webId: '',
  profileImage: undefined
}

export interface IGetAuth {
  result: string;
  data: IAuth;
}

export interface IAuthReq {
  webId: string;
  webPass: string;
}

export interface IServerDate {
  serverDate: string;
}

export interface IGetServerDate extends IResponse<IServerDate> {}

export interface IGetJwtToken extends IResponse<string> {}

export interface IJwtTokenReq {
  adminMemCode: string;
  studentMemCode: string;
}


/* geunhyung.kim 작업대 */


export interface ICheckReq {
  memberType: string;
  webId?: string;
  phoneNumber?: string;
}


export interface IMemberCheckReq {
  memberType: string;
  webId?: string;
  memberName?: string;
}

export interface IGenerateReq {
  status: 'SM'|'EM';
  webId: string;
  memberName: string;
  value: string;
  sendType?: 'LG' | 'ID' | 'PW';
}

export interface IGetResult {
  result: string;
  data: string; // token
}

export interface IConfirmReq {
  token: string;
  tokenTarget: string; // phoneNumber or email
  certifyKey: string;
}



export interface IIdInfo {
  webID: string;
  firstRegDttm: string;
}

export interface IFindIdParams {
  mobilePhone?: string;
  email?: string;
}

export interface IFindId extends IResponse<IIdInfo> {}

export interface IVerifyForPasswordReq {
  webId: string;
  memberName: string;
  token: string;
  memberType: 'E' | 'P' | 'S';
}

export interface IVerifyForPasswordResult {
  memberCode: string;
  webId: string;
  token: string;
}

export interface IGetVerifyResult extends IResponse<IVerifyForPasswordResult> {}

export interface IResetPasswordReq {
  memberCode: string;
  webPass: string;
  token: string;
}

export interface IPhoneCodeToken {
  token: string;
  key?: string;
};

export interface IAuthFind {
  memberCode: string;
  mobilePhone: string;
  webId: string;
  dormantStt: string;
  appReceiptionYN: string;
  hasCI: string;
}

export interface IGetAuthFind {
  result: string;
  data: IAuthFind;
}
